<template>
  <div class="image-teaser-component">
    <Heading
      v-if="headline.text"
      color="blue"
      weight="normal"
      class="mb-8"
      tag="h2"
    >
      {{ headline.text }}
    </Heading>
    <EditableArea :content="main" :custom-view="ImageTeaserComponentArea" />
  </div>
</template>

<script setup>
import { EditableArea } from "@magnolia/vue-editor";
import ImageTeaserComponentArea from "./ImageTeaserComponentArea";
import { Heading } from "~/components/clarity-ui/Heading";

const props = defineProps(["main", "headline", "ratio"]);

provide("ratio", props?.ratio);
</script>
